import React, { Component } from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Auth from '../Auth/Auth';

const theme = createMuiTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: '#000',
            dark: "#3182c1",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        text: {
            // Use the system font instead of the default Roboto font.
            primary: '#3182c1',
        },
        // error: will use the default color
    },
    typography: {
        // Use the system font instead of the default Roboto font.
        fontFamily: 'Wfvisualsans, Helvetica Neue, Helvetica, Arial, sans-serif',
    },

});

class SimpleLayout extends Component {
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.state = {
        };
    }

    login = e => {
        e.preventDefault()

        this.auth.login();
    }

    render() {

        return (
            <MuiThemeProvider theme={theme}>
                <div className="main__container simple-layout">
                    <nav className="navigation-navbar builder-desktop-navbar builder-navbar navbar navbar-default">
                        <div className="container-fluid">
                            <div className="navbar-header">
                                <div className="brand">
                                    <a href="/apps">
                                        <img src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/logo-color-square.svg" className="logo" />
                                    </a>
                                </div>
                            </div>
                            {!this.props.hideRightNavLinks &&
                                <div className="already-have-account">Already have an account? <a href="#" onClick={e => this.login(e)} >Sign In</a></div>
                            }
                          
                        </div>
                    </nav>
                    <section className="app-builder__body">
                        <div className="app-style-page app-builder-page layout">
                            {this.props.children}

                        </div>
                    </section>
                </div>
            </MuiThemeProvider>
        );
    }
}

export default SimpleLayout;